export default __webpack_public_path__ + "static/media/largelogoLight.935be6ff.png";